/** @jsx jsx */
import { jsx, css } from '@emotion/core'

const Color = css`
  width: inherit;
  height: auto;
`

export default function BettorFindIco() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" css={Color}>
      <g id="그룹_6753" data-name="그룹 6753" transform="translate(-3008 -5934)">
        <rect id="사각형_6317-5" data-name="사각형 6317-5" width="22" height="22" transform="translate(3008 5934)" fill="#ff0" opacity="0"/>
        <circle id="타원_602" data-name="타원 602" cx="10" cy="10" r="10" transform="translate(3008.709 5935)" fill="none"/>
        <path id="패스_6160" className="fill" data-name="패스 6160" d="M398.792,608.069a10,10,0,1,1,10-10A10,10,0,0,1,398.792,608.069Zm0-18.5a8.5,8.5,0,1,0,8.5,8.5h0A8.51,8.51,0,0,0,398.792,589.569Z" transform="translate(2619.917 5346.93)" fill="#1c202b"/>
        <rect id="사각형_6294" data-name="사각형 6294" width="1.453" height="4.951" rx="0.726" transform="translate(3024.763 5951.499) rotate(-45)" fill="#1c202b"/>
        <circle id="타원_603" data-name="타원 603" cx="2.646" cy="2.646" r="2.646" transform="translate(3016.063 5939.892)" fill="none"/>
        <path id="패스_6161" className="fill" data-name="패스 6161" d="M398.792,598.253a2.646,2.646,0,1,1,2.646-2.647,2.646,2.646,0,0,1-2.646,2.647Zm0-3.792a1.146,1.146,0,1,0,1.146,1.146h0A1.146,1.146,0,0,0,398.792,594.461Z" transform="translate(2619.917 5346.93)" fill="#1c202b"/>
        <path id="패스_6178" className="fill" data-name="패스 6178" d="M399.123,598.915h-.662a6.279,6.279,0,0,0-5.208,2.766,6.625,6.625,0,0,0,1.034,1.224,4.762,4.762,0,0,1,4.174-2.49h.662a4.764,4.764,0,0,1,4.175,2.49,6.664,6.664,0,0,0,1.034-1.224A6.279,6.279,0,0,0,399.123,598.915Z" transform="translate(2619.917 5346.93)" fill="#1c202b"/>
      </g>
    </svg>
  )
}
